import React, {useEffect, useRef, useState} from "react";
import '../../driveContextualMenu/fileUploadMenu/fileQueueLine/fileQueueLine.css';
import './fireRow.css';
import {
    checkNode,
    formatDate,
    formatFileSize,
    getFileExtension,
    getFileName,
    getIconOfName, isMobileDevice
} from "../../../../utils/utils";
import {useIntl} from "react-intl";
import InputSaveEdit from "../../../shared/inputSaveEdit";
import {useDispatch, useSelector} from "react-redux";
import drive from "../../index";
import app from "../../../app";
import users from "../../../users";
import {toast} from "react-toastify";
import {getFileUrl} from "../../../../utils/consts";

function FileRow({
                     showOptions,
                     params,
                     onDelete,
                     onClick,
                     selected,
                     isFolder,
                     onToggleSelected,
                     onRestore,
                     loading,
                     onRightClick,
                     active,
                     changeName,
                     onNameSaved,
                     disabled,
                     goBack,
                     draggable,
                     draggingItem,
                     setDraggingItem,
                     onDragOverFolder,
                     movingItems,
                     uploadUtils,
                     thisFolder,
                     customClass,
                     customStyleName,
                     customStyleIcon,
                     customClassIcon,
                     customClassName,
                     hideInfo,
                     singleClick
                 }) {

    const intl = useIntl();
    const dispatch = useDispatch();
    const [itemName, setItemName] = useState(params?.fileName ?? params?.folderName);
    const rowRef = useRef(null);
    const darkMode = useSelector(users.selectors.isDarkMode);

    useEffect(() => {
        setItemName(params?.fileName ?? params?.folderName);
    }, [params]);

    if (params === null) {
        return null;
    }

    const handleDragStart = (event) => {
        if (setDraggingItem) {
            setDraggingItem(params);
            dispatch(drive.actions.startingDraggingItem());
        }
        // Establece la información de transferencia (data transfer)
        event.dataTransfer.setData("text/plain", params.id);
    };

    const handleDragEnd = (event) => {
        event.preventDefault();
        dispatch(drive.actions.stoppedDraggingItem());
        setDraggingItem(null);
    }

    const handleDragExit = (event) => {
        rowRef.current.classList.remove('list-group-item-info');
        rowRef.current.classList.remove('list-group-item-danger');
    }

    const handleDragOver = (event) => {
        // Permite que los elementos se puedan soltar en esta área
        event.preventDefault();
        const check = checkNode(event.target, ['fileRow__buttonFile']);
        if (params.fileName || check || draggingItem?.id === params.id) {
            rowRef.current.classList.add('list-group-item-danger');
            return;
        }
        rowRef.current.classList.add('list-group-item-info');
    };

    const handleDrop = (event) => {
        // Previene el comportamiento predeterminado del navegador al soltar el elemento
        event.preventDefault();
        rowRef.current.classList.remove('list-group-item-info');

        if(draggingItem && draggingItem.id === params.id && params.folderName) {
            rowRef.current.classList.remove('list-group-item-danger');
            toast.error(intl.formatMessage({id: "drive.file-row.error-dragging"}));
            return;
        }

        // Movemos algo dentro de esta carpeta
        if (draggingItem && params.folderName) {
            onDragOverFolder(draggingItem, params);
            dispatch(drive.actions.stoppedDraggingItem());
        } else if (params.folderName) {
            uploadUtils.current.dropHandler(event, params.id);
        } else {
            rowRef.current.classList.remove('list-group-item-danger');
        }
    };

    return (
        <button
            className={"list-group-item list-group-item-action fileRow__buttonItem " + (selected && " list-group-item-info ") + (active && " active ") + (disabled && " fileRow__disabled ") +
                (isFolder ? " fileRow__buttonFolder " : " fileRow__buttonFile ") + customClass} ref={rowRef}
            style={{transition: '0.4s'}}
            key={params.id} disabled={disabled}
            draggable={draggable && !loading && !disabled && !selected && !changeName}
            onDragStart={handleDragStart}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            onDragLeave={handleDragExit}
            onDragEnd={handleDragEnd}
            onAuxClick={e => {
                if (onRightClick && !loading && !changeName && !disabled) {
                    onRightClick(e);
                }
            }}
            onDoubleClick={() => {
                if (!loading && !changeName && !disabled && !isMobileDevice() && !movingItems) {
                    onClick(params)
                }
            }}
            onClick={() => {
                if (!loading && !changeName && !disabled && (isMobileDevice() || movingItems || singleClick)) {
                    onClick(params)
                }
            }}>
            <div className="col-12 d-flex flex-row">
                <div className={"col-1 me-3 d-flex justify-content-center align-items-center " + customClassIcon}
                     style={{width: '40px', height: '40px', ...customStyleIcon}}>
                    {!isFolder && params.fileType?.includes("image") &&
                        <img
                            style={{width: '100%', height: '100%', objectFit: 'cover'}}
                            src={getFileUrl(params)}
                            alt={itemName}
                        />}
                    {!isFolder && params.fileType?.includes("video") &&
                        <i className={"fa-regular fa-file-video fa-2xl " + (active ? "text-light" : "text-muted")}></i>
                    }
                    {!isFolder && params.fileType?.includes("audio") &&
                        <i className={"fa-regular fa-file-audio fa-2xl " + (active ? "text-light" : "text-muted")}></i>
                    }{
                    isFolder && thisFolder ?
                        <i className={"fa-regular fa-folder-open fa-2xl " + (active ? "text-light" : "text-muted")}></i>
                        : ((isFolder && !goBack) ?
                            <i className={"fa-regular fa-folder fa-2xl " + (active ? "text-light" : "text-muted")}></i>
                            : (isFolder && goBack &&
                                <i className={"fa-solid fa-circle-arrow-left fa-2xl " + (active ? "text-light" : "text-muted")}></i>))

                }

                    {(!isFolder && !params.fileType?.includes("image") && !params.fileType?.includes("video") && !params.fileType?.includes("audio")) &&
                        <i className={getIconOfName(params) + " fa-2xl " + (active ? "text-light" : "text-muted")}></i>
                    }
                </div>
                {!changeName && <div style={{height: '40px'}}
                                     className={(isMobileDevice() ? "col-9" : "col-10") + " d-flex "
                                         + (isFolder ? "flex-row align-items-center " : "flex-column ")
                                         + (active ? "text-light" : (darkMode ? "text-muted" : "text-dark"))
                                         + " " + customClassName}>

                    <div className={!customStyleName && "truncated-text"}
                         style={{...customStyleName}}>
                        <span>{itemName}</span>
                    </div>

                    {!isFolder && !hideInfo &&
                        <div style={{fontSize: "x-small", fontWeight: "lighter"}}
                             className={(active ? "text-light" : "text-muted")}>
                            <span>{formatDate(params.uploadDate)}</span> | <span>{formatFileSize(params.size)}</span>
                            {showOptions &&
                                <span> | <i className="fa-solid fa-ellipsis ms-1 fa-2xl fileRow__buttonOptions"
                                            onClick={e => {
                                                if (onRightClick && !loading && !changeName) {
                                                    onRightClick(e);
                                                }
                                            }}></i>
                                </span>}
                        </div>}
                    {(isFolder && showOptions) &&
                        <span className={(active ? "text-light" : "text-muted")}>
                            <i className="fa-solid fa-ellipsis-vertical ms-2 fa-lg fileRow__buttonOptions"
                               onClick={e => {
                                   if (onRightClick && !loading && !changeName) {
                                       onRightClick(e);
                                   }
                               }}></i>
                        </span>}
                </div>}
                {changeName && <div style={{height: '40px'}}
                                    className={(isMobileDevice() ? "col-9" : "col-10") + " d-flex flex-row align-items-center " + (active ? "text-light" : "text-dark")}>
                    <div className="input-group input-group-sm mb-0 col-11 d-flex align-items-center">
                        <InputSaveEdit inputValue={isFolder ? itemName : getFileName(itemName)} startEditing={true}
                                       maxLength={60}
                                       onSave={value => {
                                            if (isFolder) {
                                                setItemName(value);
                                                onNameSaved(value, params)
                                                return;
                                            }
                                            // En caso de un archivo, añadimos la extensión
                                            const newItemName = value + "." + getFileExtension(params.fileName ?? params.folderName);
                                            setItemName(newItemName);
                                            onNameSaved(newItemName, params);
                                        }}/>

                    </div>
                    <div className="col-1">

                    </div>
                </div>
                }
                {(onToggleSelected && !loading && !disabled) && <div style={{height: '40px'}}
                                                                     className={"col-1 d-flex flex-row align-items-center justify-content-center " + (active ? "text-light" : "text-muted")}
                                                                     onClick={e => {
                                                                         e.stopPropagation();
                                                                         onToggleSelected(params);
                                                                     }}>

                    {!selected && <i className="fa-regular fa-square fa-xl"></i>}
                    {selected && <i className="fa-regular fa-square-check fa-fade fa-xl"></i>}
                </div>}
                {((onDelete || onRestore) && !loading) && <div style={{height: '40px'}}
                                                               className={"col-1 d-flex flex-column align-items-center justify-content-center " + (active ? "text-light" : "text-muted")}
                                                               onClick={e => {
                                                                   if (onToggleSelected) {
                                                                       e.stopPropagation();
                                                                       onToggleSelected(params);
                                                                   }
                                                               }}>
                    {onDelete && <div onClick={e => {
                        e.stopPropagation();
                        onDelete(params);
                    }}
                    ><i title={intl.formatMessage({id: "drive.file-row.delete-button"})}
                        className="fa-solid fa-trash fa-lg fileRow__buttonDelete"></i></div>}
                    {onRestore && <div onClick={e => {
                        e.stopPropagation();
                        onRestore(params);
                    }}><i title={intl.formatMessage({id: "drive.file-row.recover-button"})}
                          className="fa-solid fa-rotate-left fa-lg fileRow__buttonRecover"></i></div>}
                </div>}
                {loading && <div style={{height: '40px'}}
                                 className={"col-1 d-flex flex-column align-items-center justify-content-center " + (active ? "text-light" : "text-muted")}>
                    <i className="fa-solid fa-circle-notch fa-spin"></i>
                </div>}
                {disabled && <div style={{height: '40px'}}
                                  className={"col-1 d-flex flex-column align-items-center justify-content-center " + (active ? "text-light" : "text-muted")}>
                    {!selected && <i className="fa-solid fa-slash fa-xl"></i>}
                    {selected && <i className="fa-regular fa-square-check fa-fade fa-xl"></i>}
                </div>}

            </div>
        </button>
    )

}

export default FileRow;
